// Polyfill for window.crypto.randomUUID() on browsers (like iOS Safari) that don't support it
(function () {
  if (typeof window !== "undefined") {
    // If the browser already supports it, do nothing
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return;
    }

    // Ensure window.crypto exists
    if (!window.crypto) {
      window.crypto = {};
    }

    // Simple UUID v4 generator (not cryptographically secure but good for IDs)
    window.crypto.randomUUID = function () {
      let uuid = "";
      for (let i = 0; i < 36; i++) {
        if (i === 8 || i === 13 || i === 18 || i === 23) {
          uuid += "-";
        } else if (i === 14) {
          uuid += "4"; // version 4 UUID
        } else {
          const r = (Math.random() * 16) | 0;
          uuid += ((i === 19 ? (r & 0x3) | 0x8 : r)).toString(16);
        }
      }
      return uuid;
    };
  }
})();
